<span #copyButtonText><ng-content></ng-content></span>
<ng-container *ngIf="copyButtonText?.children.length === 0">
  <input
    type="button"
    class="btn"
    [ngClass]="btnClass"
    value="{{ copiedToClipboard ? copiedText : copyText }}" />
</ng-container>
